import log from 'loglevel'
import axios from 'axios'

/* eslint class-methods-use-this: ["off"] */

export default class Powers {
  constructor() {
    log.info('[INFO] Initialize Powers Module')
  }

  fetchPowers(params) {
    let parameters = {}

    if (params) {
      parameters = {
        params,
      }
    }

    return new Promise((resolve, reject) => {
      axios
        .get('v1/pncp/powers/', parameters)
        .then(response => {
          log.debug('[DEBUG] Success to fetch powers')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to fetch powers')
          log.error(error)
          reject(error.response)
        })
    })
  }

  fetchPower(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`v1/pncp/powers/${id}/`)
        .then(response => {
          log.debug('[DEBUG] Success to fetch power')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to fetch power')
          log.error(error)
          reject(error.response)
        })
    })
  }

  updatePower(id, powerData) {
    return new Promise((resolve, reject) => {
      axios
        .put(`v1/pncp/powers/${id}/`, powerData)
        .then(response => {
          log.debug('[DEBUG] Success to update power')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to update power')
          log.error(error)
          reject(error.response)
        })
    })
  }

  addPower(powerData) {
    return new Promise((resolve, reject) => {
      axios
        .post('v1/pncp/powers/', powerData)
        .then(response => {
          log.debug('[DEBUG] Success to add power')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to add power')
          log.error(error)
          reject(error.response)
        })
    })
  }

  deletePower(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`v1/pncp/powers/${id}/`)
        .then(() => {
          log.debug('[DEBUG] Success to delete power')
          resolve()
        })
        .catch(error => {
          log.error('[ERROR] Fail to delete power')
          log.error(error)
          reject(error.response)
        })
    })
  }
}
